import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const ArrowDropDownIcon = ({ sx, ...props }: Props) => (
  <SvgIcon viewBox="0 0 20 20" sx={{ color: 'gray', ...sx }} {...props}>
    <path d="M14.17 7.64a.83.83 0 0 0-1.18 0L10 10.6 7.05 7.64a.83.83 0 1 0-1.17 1.19l3.53 3.53a.83.83 0 0 0 1.18 0l3.58-3.53a.83.83 0 0 0 0-1.19Z" />
  </SvgIcon>
)

ArrowDropDownIcon.defaultProps = {
  sx: null,
}
